import Lottie from "lottie-react";
import { useDefaultRestaurant } from "../../hooks/useRestaurantEta";
import useLottieJson from "../../hooks/useLottieJson";

// Proporción del alto natural del Lottie que se muestra. <1 recorta arriba y
// abajo por igual. Subir a 1 devuelve el banner a su alto completo.
const BANNER_CROP = 1;

/**
 * Banner promocional del home: Lottie (.json) que el admin sube desde el
 * dashboard (Business.promoBanner = URL). El aspect ratio se toma del propio
 * Lottie (w/h) para reservar el alto correcto y evitar layout shift.
 * Si no hay banner configurado, no renderiza nada.
 */
export default function PromotionsBanner() {
  const restaurant = useDefaultRestaurant();
  const animationData = useLottieJson(restaurant?.promoBanner);

  if (!animationData) return null;

  const w = animationData.w || 2160;
  const h = animationData.h || 950;

  return (
    // El contenedor reserva un alto CROP% del natural y recorta parejo arriba y
    // abajo (el Lottie va centrado a ancho completo). Así el banner pesa menos
    // sin deformar la animación — escalar el aspect-ratio la dejaría con
    // letterbox a los lados, porque el SVG preserva su proporción.
    <div
      className="relative w-full overflow-hidden bg-promo-section-bg"
      style={{ aspectRatio: `${w} / ${h * BANNER_CROP}` }}
    >
      <div className="absolute inset-0 flex items-center">
        <Lottie
          animationData={animationData}
          loop
          autoplay
          className="w-full block"
        />
      </div>
    </div>
  );
}
